import { Stack, Typography } from "@mui/material";
import React from "react";
import { getMeasureCaption } from "../../../../viewer/common/values/helper.tsx";
import BarWidthItem from "./BarWidthItem.tsx";
import SerieLineTypeItem from "./SerieLineTypeItem.tsx";
import SerieTypeItem from "./SerieTypeItem.tsx";
import SerieValueAxis from "./SerieValueAxis.tsx";
import ShowLabelConnectorItem from "./ShowLabelConnectorItem.tsx";
import ShowLabelItem from "./ShowLabelItem.tsx";
import ShowPointsItem from "./ShowPointsItem.tsx";
import type { ChartStyleSettings, ReportField, SeriesSettings } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  settings: ChartStyleSettings;
  values: ReportField[];
  serie: SeriesSettings;
  readonlyMode: boolean;
}

export default function SerieItem({ settings, values, serie, readonlyMode }: Props) {
  const caption = React.useMemo(() => {
    const measure = values.find((v) => v.config.guid === serie.name);
    return getMeasureCaption(measure);
  }, [serie.name, values]);

  return (
    <Stack spacing={1} useFlexGap sx={{ width: "100%" }}>
      <Typography variant="subtitle2">{caption}</Typography>
      <SerieTypeItem settings={settings} serie={serie} readonlyMode={readonlyMode} />
      <BarWidthItem settings={settings} serie={serie} readonlyMode={readonlyMode} />
      <SerieLineTypeItem settings={settings} serie={serie} readonlyMode={readonlyMode} />
      <SerieValueAxis settings={settings} serie={serie} readonlyMode={readonlyMode} />
      <ShowPointsItem settings={settings} serie={serie} readonlyMode={readonlyMode} />
      <ShowLabelItem settings={settings} serie={serie} readonlyMode={readonlyMode} />
      <ShowLabelConnectorItem settings={settings} serie={serie} readonlyMode={readonlyMode} />
    </Stack>
  );
}
